import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
import $ from 'jquery';
import getPx from '@/utils/getPx';
import { signalTopicList, follow, unFollow, thumbs, collect } from '@/api/mg';
export default {
  data: function data() {
    return {
      userId: '',
      transitionName: '',
      arr: ['Hot', 'Latest'],
      activeName: 'Hot',
      infos: [
        // { isFollow: true },
        // { isFollow: false },
        // { isFollow: true },
        // { isFollow: false }
      ],
      topicId: '',
      from: ''
    };
  },
  created: function created() {
    this.userId = localStorage.getItem('userId');
    var topicId = this.$route.query.topicId;
    this.topicId = topicId;
    console.log(topicId, 'topicId');
    this.isBack = localStorage.getItem('isBack');
    var params = {
      'filter[topicId]': topicId,
      'filter[hot]': 0
    };
    this.getTopicList(params);
  },
  methods: {
    toCollect: function toCollect(item) {
      var _this = this;
      var params = {
        id: item.threadId,
        isFavorite: !item.isFavorite
      };
      collect(params).then(function (res) {
        if (res.Code === 0) {
          if (item.isFavorite) {
            item.likeReward.favoriteCount -= 1;
          } else {
            item.likeReward.favoriteCount += 1;
          }
          item.isFavorite = !item.isFavorite;
        } else {
          _this.$toast(res.Message);
        }
      });
    },
    thumbsUp: function thumbsUp(item) {
      var _this2 = this;
      var params = {
        data: {
          attributes: {
            isLiked: !item.isLike
          }
        },
        pid: item.postId,
        id: item.threadId
      };
      params.token = JSON.parse(localStorage.getItem('appParams')).token;
      thumbs(params).then(function (res) {
        if (res.Code === 0) {
          if (item.isLike) {
            item.likeReward.likePayCount -= 1;
          } else {
            item.likeReward.likePayCount += 1;
          }
          item.isLike = !item.isLike;
        } else {
          _this2.$toast(res.Message);
        }
      });
    },
    toMe: function toMe(pid) {
      this.$router.push({
        path: '/others',
        query: {
          pid: pid
        }
      });
    },
    toFollow: function toFollow(userId, item) {
      var _this3 = this;
      var params = {
        toUserId: userId
      };
      follow(params).then(function (res) {
        if (res.Code === 0) {
          item.user.followStatus = '0';
        } else {
          _this3.$toast(res.Message);
        }
      });
    },
    toUnfollow: function toUnfollow(userId, item) {
      var _this4 = this;
      var params = {
        type: 1,
        id: userId
      };
      console.log(unFollow, 'params');
      unFollow(params).then(function (res) {
        if (res.Code === 0) {
          item.user.followStatus = '2';
        } else {
          _this4.$toast(res.Message);
        }
      });
    },
    toDetail: function toDetail(threadId) {
      this.$router.push({
        path: '/social/detail',
        query: {
          from: 'club',
          threadId: threadId
        }
      });
    },
    getTopicList: function getTopicList(params) {
      var _this5 = this;
      signalTopicList(params).then(function (res) {
        if (res.Code === 0) {
          _this5.infos = res.Data.pageData;
          if (_this5.infos.length == 0 || _this5.infos[0].threads.length == 0) {
            // eslint-disable-line
            _this5.$toast(_this5.$t('NoData'));
            var timer = setTimeout(function () {
              _this5.$router.back();
              clearTimeout(timer);
            }, 1000);
          }
          console.log(_this5.infos, 'this.infos');
          _this5.$nextTick(function () {
            $('.club').height($(window).height() - $('.img-con-top').innerHeight() - $('.van-tabs__wrap').height() - getPx(50) + getPx(60));
            console.log($('.club').height(), "$('.club').height()");
            var u = navigator.userAgent; // 判断手机类型
            if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
              console.log('12345');
              if (window.Android) {
                var devicePixelRatio = window.devicePixelRatio;
                console.log(devicePixelRatio);
                console.log(window.Android.getStatusBarHeight());
                var pxSize = Number(window.Android.getStatusBarHeight() / devicePixelRatio);
                console.log('pxsize', pxSize);
                $('#img-wrap').css('padding-top', pxSize);
              }
            }
          });
        } else {
          // this.$toast(res.Message)
        }
      });
    },
    share: function share() {
      this.$toast('调用原生分享');
    },
    back: function back() {
      var _this6 = this;
      var timer = setTimeout(function () {
        _this6.$router.back();
        clearTimeout(timer);
      }, 100);
    },
    tabChange: function tabChange(name, title) {
      // const obj = { 'hot': 0, 'latest': 1 }
      // const params = { 'filter[topicId]': 2, 'filter[hot]': obj[name] }
      // this.getTopicList(params)
      var params;
      if (name === 'Hot') {
        params = {
          'filter[topicId]': this.topicId,
          'filter[hot]': 0
        };
      } else {
        params = {
          'filter[topicId]': this.topicId
        };
      }
      this.getTopicList(params);
      this.$nextTick(function () {
        $('.club').height($(window).height() - $('.img-con-top').innerHeight() - $('.van-tabs__wrap').height() - getPx(50) + getPx(60));
      });
    }
  }
};